var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import categoriesService from "@irati/deals/services/dealCategory";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import ThirdImage from "@irati-web/wallet/src/images/wallet_badge.svg";
import Button from "@irati/ui/src/Button";
import Link from "@irati/ui/src/Link";
import Flex from "@irati/ui/src/Flex";
import { H1, Body } from "@irati/ui/src/Typography";
import perksGOTracking from "@irati-tracking/perksgo/perksGO";
import Step from "./Step";
import perksGOLogo from "../../../images/perksGO_logo.svg";
import FirstImage from "../../../images/perksGO_badge.svg";
import SecondImage from "../../../images/SecondPerksGO.png";
import { StyledModal, PerksGOLogo, LinkWrapper, ButtonWrapper, StyledClose } from "./styled";
import LinkCardPopup from "../LinkCard";
var FindOutMore = /** @class */ (function (_super) {
    __extends(FindOutMore, _super);
    function FindOutMore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            show: false
        };
        _this.componentDidMount = function () {
            /**
             * Front-load list of categories to be used in the last modal (Success) of this flow
             * after the user has linked its card with Fidel
             * this allows us to extract data directly from the apollo-client cache instead of the BE graph API
             */
            categoriesService.listForCurrentPackage();
        };
        _this.show = function () {
            _this.setState({ show: true });
        };
        _this.hide = function () {
            _this.setState({ show: false });
            var onHide = _this.props.onHide;
            if (onHide) {
                onHide();
            }
        };
        _this.showLinkCardModal = function () {
            _this.setState({ show: false }, function () {
                perksGOTracking.showLinkCardModal(_this.props.modalLocation);
                _this.linkCardPopup.wrappedInstance.show();
            });
        };
        return _this;
    }
    FindOutMore.prototype.render = function () {
        var _this = this;
        var _a = this.props, isInDeal = _a.isInDeal, formatMessage = _a.formatMessage, onHide = _a.onHide, linkedCards = _a.linkedCards;
        var show = this.state.show;
        return (React.createElement(React.Fragment, null,
            React.createElement(StyledModal, { show: show, onHide: this.hide },
                React.createElement(Flex, { justifyContent: "center", alignItems: "center", padding: [3, 0] },
                    React.createElement(PerksGOLogo, { src: perksGOLogo, alt: formatMessage({ id: "platform.perksGO.popup.findOutMore.logo.alt" }) }),
                    React.createElement(H1, { marginLeft: 2 },
                        React.createElement(FormattedMessage, { id: "platform.perksGO.popup.findOutMore.logo.text" }))),
                React.createElement(Body, { textAlign: "center", color: "ink", marginBottom: 2 },
                    React.createElement(FormattedMessage, { id: "platform.perksGO.popup.findOutMore.header" })),
                React.createElement(Flex, { justifyContent: "center" },
                    React.createElement(Body, { textAlign: "center", small: true },
                        React.createElement(FormattedMessage, { id: "platform.perksGO.popup.findOutMore.subHeader", values: {
                                boldText: (React.createElement("strong", null,
                                    React.createElement(FormattedMessage, { id: "platform.perksGO.popup.findOutMore.boldText" })))
                            } }))),
                React.createElement(Flex, { direction: "column", margin: [4, 0] },
                    React.createElement(Step, { image: FirstImage, imageAlt: formatMessage({ id: "platform.perksGO.popup.findOutMore.step1.alt" }), header: formatMessage({ id: "platform.perksGO.popup.findOutMore.step1.header" }), desc: formatMessage({ id: "platform.perksGO.popup.findOutMore.step1.desc" }) }),
                    React.createElement(Step, { image: SecondImage, imageAlt: formatMessage({ id: "platform.perksGO.popup.findOutMore.step2.alt" }), header: formatMessage({ id: "platform.perksGO.popup.findOutMore.step2.header" }), desc: formatMessage({ id: "platform.perksGO.popup.findOutMore.step2.desc" }) }),
                    React.createElement(Step, { image: ThirdImage, imageAlt: formatMessage({ id: "platform.perksGO.popup.findOutMore.step3.alt" }), header: formatMessage({ id: "platform.perksGO.popup.findOutMore.step3.header" }), desc: formatMessage({ id: "platform.perksGO.popup.findOutMore.step3.desc" }) })),
                React.createElement(ButtonWrapper, null,
                    React.createElement(Button, { full: true, large: true, primary: true, onClick: this.showLinkCardModal },
                        React.createElement(FormattedMessage, { id: "platform.perksGO.popup.findOutMore.button.text" }))),
                React.createElement(LinkWrapper, null,
                    React.createElement(Link, { href: formatMessage({ id: "platform.perksGO.popup.findOutMore.link.href" }), target: "_blank" },
                        React.createElement(FormattedMessage, { id: "platform.perksGO.popup.findOutMore.link.text" }))),
                React.createElement(StyledClose, { inline: false, onClick: this.hide })),
            React.createElement(LinkCardPopup, { ref: function (c) {
                    _this.linkCardPopup = c;
                }, isInDeal: isInDeal, onHide: onHide, linkedCards: linkedCards })));
    };
    FindOutMore.defaultProps = {
        isInDeal: false
    };
    return FindOutMore;
}(Component));
export default injectIntl(FindOutMore, { withRef: true });
